export function PartialCircle({ className = "" }) {
  return (
    <svg viewBox="0 0 300 300" fill="none" className={className} aria-hidden="true">
      <path
        d="M158 10 a140 140 0 1 0 100 46"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M170 30 a120 120 0 1 0 84 38"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.6"
      />
    </svg>
  );
}

function Leaf({ transform, stroke = "#966E50", opacity = 0.8 }) {
  return (
    <g transform={transform}>
      <path
        d="M0 0 C 24 -34, 68 -30, 88 -2 C 64 26, 20 28, 0 0 Z"
        stroke={stroke}
        strokeWidth="1.2"
        fill="none"
        opacity={opacity}
      />
      <path d="M6 0 C 34 -6, 60 -6, 84 -2" stroke={stroke} strokeWidth="0.9" opacity={opacity * 0.7} />
    </g>
  );
}

function Cherry({ cx, cy, stroke = "#B86F52", opacity = 0.8 }) {
  return <circle cx={cx} cy={cy} r="11" stroke={stroke} strokeWidth="1.3" fill="none" opacity={opacity} />;
}

export function Branch({ className = "" }) {
  return (
    <svg viewBox="0 0 420 560" fill="none" className={className} aria-hidden="true">
      <path
        d="M36 540 C 120 440, 190 320, 250 200 S 350 80, 404 24"
        stroke="#966E50"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.75"
      />
      <Leaf transform="translate(96 448) rotate(-30)" stroke="#A7B39F" />
      <Leaf transform="translate(150 366) rotate(14) scale(-1 1)" stroke="#966E50" />
      <Leaf transform="translate(196 282) rotate(-38)" stroke="#304A3A" opacity={0.7} />
      <Leaf transform="translate(246 196) rotate(20) scale(-1 1)" stroke="#A7B39F" opacity={0.75} />
      <Leaf transform="translate(296 116) rotate(-24)" stroke="#966E50" />
      <path d="M212 236 q-18 24 -34 34" stroke="#966E50" strokeWidth="1.1" opacity="0.7" />
      <path d="M226 226 q6 26 2 44" stroke="#966E50" strokeWidth="1.1" opacity="0.7" />
      <Cherry cx="168" cy="284" />
      <Cherry cx="188" cy="296" stroke="#966E50" />
      <Cherry cx="228" cy="282" stroke="#304A3A" opacity={0.7} />
      <path d="M320 120 q-20 18 -40 26" stroke="#966E50" strokeWidth="1.1" opacity="0.7" />
      <Cherry cx="272" cy="150" stroke="#966E50" />
      <Cherry cx="292" cy="158" stroke="#B86F52" />
    </svg>
  );
}

export function CherryCluster({ className = "" }) {
  return (
    <svg viewBox="0 0 260 260" fill="none" className={className} aria-hidden="true">
      <path d="M130 16 C 120 70, 108 120, 96 164 M130 16 C 142 66, 152 112, 162 152" stroke="#966E50" strokeWidth="1.3" strokeLinecap="round" opacity="0.7" />
      <Leaf transform="translate(140 92) rotate(-16)" stroke="#A7B39F" opacity={0.9} />
      <Cherry cx="92" cy="178" />
      <Cherry cx="118" cy="190" stroke="#966E50" />
      <Cherry cx="166" cy="168" stroke="#966E50" opacity={0.85} />
      <Cherry cx="140" cy="182" stroke="#304A3A" opacity={0.7} />
    </svg>
  );
}
